import React, { useState, useContext } from "react";
import { bulkInventoryUploadService } from "../../services/bulk-inventory-upload.service";
import DContext from "../../context/DContext";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const BulkInventoryUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const { authState } = useContext(DContext);
  //const { user } = authState;

  const handleSampleDownload = async () => {
    setIsDownloading(true);

    try {
      const apiRes = await bulkInventoryUploadService.downloadTemplate();
      if (apiRes.success) {
        toast.success(apiRes.message);
      } else {
        toast.error(apiRes.message || "Something went wrong...");
      }
    } catch (error) {
      toast.error("Failed to download sample file");
      console.error("Download error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleFileUploadChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please Select a File");
      return;
    }
    
    //if (!user?.id) {
    if (!authState?.userProfile?.id) {
      toast.error("Supplier information not found");
      return;
    }

    setIsUploading(true);
    try {
      const apiRes = await bulkInventoryUploadService.upload({
        inventory_data: selectedFile,
        supplier_id: Number(authState?.userProfile?.id),
      });
      if (apiRes.success) {
        toast.success(apiRes.message);
        setSelectedFile(null);
      } else {
        toast.error(apiRes.message || "Failed to upload file");
      }
    } catch (error) {
      toast.error("Failed to upload file");
      console.error("Upload error:", error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      <div className="mb-3">
        <h4 className="m-0 fw-bold" style={{ color: "var(--page-heading)", fontSize: 20 }}>
          Bulk Inventory Upload
        </h4>
        <nav className="d-flex align-items-center gap-1 mt-1" style={{ fontSize: 12, color: "#475569" }}>
          <Link to="/dashboard" style={{ color: "#475569" }}>
            <i className="bi bi-house-door"></i>
          </Link>
          <i className="bi bi-chevron-right" style={{ fontSize: 9 }}></i>
          <Link to="/inventory/list" style={{ color: "#475569" }}>
           Inventory
          </Link>
          <i className="bi bi-chevron-right" style={{ fontSize: 9 }}></i>
          <span className="fw-semibold" style={{ color: "#4a5568" }}>
           Bulk Inventory Upload
          </span>
        </nav>
      </div>
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        border: "1px solid #e8ecf4",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "16px 22px",
          borderBottom: "1px solid #f0f2f8",
          display: "flex",
          alignItems: "center",
          gap: 12,
        }}
      >
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            background: "#e6f1f8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <i
            className="fa-solid fa-cloud-arrow-up"
            style={{ color: "var(--btn-bg)", fontSize: 16 }}
          />
        </div>
        <span style={{ fontWeight: 700, fontSize: 15, color: "var(--btn-hover-bg)" }}>
          Bulk Inventory Upload
        </span>
        <button
          type="button"
          className="ms-auto"
          onClick={handleSampleDownload}
          disabled={isDownloading}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 7,
            padding: "8px 16px",
            borderRadius: 8,
            border: "1.5px solid var(--btn2-border)",
            background: "var(--btn2-bg)",
            color: "var(--btn2-text)",
            fontWeight: 600,
            fontSize: 13,
            cursor: isDownloading ? "not-allowed" : "pointer",
            opacity: isDownloading ? 0.7 : 1,
          }}
        >
          <i
            className={`fa-solid ${isDownloading ? "fa-spinner fa-spin" : "fa-download"}`}
            style={{ fontSize: 13 }}
          />
          {isDownloading ? "Preparing Download..." : "Download Sample CSV"}
        </button>
      </div>

      <div style={{ padding: "28px 22px" }}>
        {/* Drop Zone */}
        <label
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            padding: "40px 24px",
            borderRadius: 12,
            border: "2px dashed #c7d0e8",
            background: "#f8f9fe",
            cursor: "pointer",
            transition: "border-color 0.2s",
            textAlign: "center",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.borderColor = "var(--btn-bg)")}
          onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#c7d0e8")}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 14,
              background: "linear-gradient(135deg, var(--btn-hover-bg) 0%, var(--btn-bg) 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 14px rgba(14,106,150,0.25)",
            }}
          >
            <i
              className="fa-solid fa-cloud-arrow-up"
              style={{ color: "#fff", fontSize: 24 }}
            />
          </div>
          <div>
            <div
              style={{
                fontWeight: 700,
                fontSize: 15,
                color: "var(--btn-hover-bg)",
                marginBottom: 4,
              }}
            >
              Drag &amp; Drop a file here
            </div>
            <div style={{ fontSize: 13, color: "#475569" }}>
              or{" "}
              <span style={{ color: "var(--btn-bg)", fontWeight: 600 }}>
                click to browse
              </span>{" "}
              from your computer
            </div>
          </div>
          {selectedFile && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "6px 14px",
                borderRadius: 20,
                background: "#ecfdf5",
                border: "1px solid #a7f3d0",
              }}
            >
              <i
                className="fa-solid fa-file-csv"
                style={{ color: "#065f46", fontSize: 13 }}
              />
              <span style={{ fontSize: 13, fontWeight: 600, color: "#065f46" }}>
                {selectedFile.name}
              </span>
            </div>
          )}
          <input
            type="file"
            name="bulkdataupload"
            onChange={handleFileUploadChange}
            hidden
          />
        </label>

        {/* Format hint */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            marginTop: 10,
            marginBottom: 0,
          }}
        >
          <i
            className="bi bi-info-circle"
            style={{ color: "#475569", fontSize: 13 }}
          />
          <span style={{ fontSize: 12, color: "#475569" }}>
            Accepted format: <strong>.csv</strong> — Download the sample file to
            see the required column structure.
          </span>
        </div>

        {/* Footer Actions */}
        {/* Footer Actions */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: 22,
            gap: 10,
          }}
        >
          <button
            onClick={handleUpload}
            disabled={isUploading}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              width: "100%",
              padding: "10px 24px",
              borderRadius: 8,
              border: "none",
              background: "linear-gradient(135deg, var(--btn-hover-bg) 0%, var(--btn-bg) 100%)",
              color: "#fff",
              fontWeight: 700,
              fontSize: 14,
              boxShadow: "0 4px 12px rgba(14,106,150,0.3)",
              cursor: isUploading ? "not-allowed" : "pointer",
              opacity: isUploading ? 0.7 : 1,
            }}
          >
            <i
              className={`fa-solid ${isUploading ? "fa-spinner fa-spin" : "fa-cloud-arrow-up"}`}
              style={{ fontSize: 14 }}
            />
            {isUploading ? "Uploading..." : "Upload Bulk Inventory"}
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default BulkInventoryUpload;
